import { jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { lazyImport } from "@nxplatform/ssr-service/utils/lazy-import";
const { BlockedPagePrivate } = lazyImport(() => import("./blocked.page.private.js"), "BlockedPagePrivate");
const BlockedPage = (props) => {
  return /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(BlockedPagePrivate, { ...props }) });
};
export {
  BlockedPage
};
